import React from 'react';
import { Button } from 'antd';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';

function FailedPayment() {
  const history = useHistory();
  const {storeData} = useSelector(state => state.fetchedData)

  return (
    <div className="checkOut-page-style">
      <div className="mt-2 p-4 h-100">
        <div className='text-center mb-4'>
          <img src={'/img/paymentFailed.svg'}/>
        </div>
        <div className={"text-center"}>
          <h2 className={'mt-2'}> Payment failed! </h2>
          <p> Your order could not be proceed, please try again.</p>
        </div>
        <div className="mt-5">
          <Button className={`w-100 orderCheckout font-bold text-black mb-2 text-center`}>
            <a href={"tel:"+storeData?.supportPhone} className="w-100 h-100 text-black flex-block">
                Get Help
            </a> 
          </Button>
          <Button onClick={() => history.push('checkOut')} className={`w-100 orderCheckout font-bold text-black primaryColor`}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FailedPayment;